'use strict';

angular.module('chatEngine.landing', [
    'chatEngine.services',
    'chatEngine.dialog'
])

.controller('LandingCtrl', ['$scope', '$window', '$http', '$location', '$timeout', '$modal', 'Dialog','socketService',
    'authService', 'sessionDataService', 'mixpanelService', 'kikService', 'alertService', 'DEBUG', 'SHARE_URL',
    'BOTSWORTH_USERNAME', 'storageService', function($scope, $window, $http, $location, $timeout, $modal, Dialog,
    socketService, authService, sessionDataService, mixpanelService, kikService, alertService, DEBUG, SHARE_URL,
    BOTSWORTH_USERNAME, storageService) {

    mixpanelService.forceTrack('Login Show');

    $scope.loadedCodeOnce = false;
    $scope.animateIn = true;
    $scope.message = 'default';

    function init() {
        if(sessionDataService.getKikUsername()) {
            $timeout(function() {
                $location.path('/reporting');
            }, 0);
            return;
        }

        authService.clearAuthCookies();
        $scope.showScanLoader = true;
        $scope.waiting = false;
        if (DEBUG && $location.search().username) {
            devLogin();
        } else if (kikService.utils && ['ios', 'android'].indexOf(kikService.utils.platform.os.name) !== -1) {
            if (kikService.enabled) {
                // Inside kik
                kikLogin();
            } else {
                // Not in kik, try to open in Kik
                $timeout(function() {
                    window.location.protocol = 'cards';
                }, 1000);
                scanLogin();
            }
        } else {
            scanLogin();
        }
    }

    function kikLogin() {
        $scope.showScanLoader = false;
        $scope.kikLogin = true;
        $scope.message = 'kikLogin';
    }

    $scope.kikAuth = function() {
        $scope.kikLogin = false;
        $scope.showScanLoader = true;
        $scope.message = 'kikLogin';
        var DATA_TO_SIGN = {data: 'login'};
        kikService.sign(JSON.stringify(DATA_TO_SIGN), function(signedData, username, host) {
            if (!signedData) {
                $scope.$apply(function() {
                    $scope.showScanLoader = false;
                    $scope.kikLogin = true;
                    $scope.message = 'kikLoginTerminated';
                });
            } else {
                $scope.showScanLoader = true;
                $http.post(
                    '/api/v1/kik-session',
                    {
                        'signedData': signedData,
                        'username': username,
                        'host': host
                    }
                ).success(function(data) {
                    if (data && data.cookie) {
                        socketService.closeSocket();
                        $scope.success = true;
                        animateLogin(data, function() {
                            authService.setEngineCookie(data.cookie);

                            $http.get('/api/v1/contact')
                                .error(function() {
                                    Dialog.alert('Error', 'An error occurred while loading your information.');
                                })
                                .success(function(response) {
                                    alertService.setShowAppleIdAlert(!response.apple_developer_id);
                                });
                        });

                        mixpanelService.forceTrack('Kik Login Success');
                    } else {
                        $scope.kikLogin = true;
                        $scope.message = 'error';

                        mixpanelService.forceTrack('Kik Login Token Error');
                    }
                })
                .error(function(data, status) {
                    $scope.showScanLoader = false;
                    if (status === 404) {
                        $scope.kikLogin = false;
                        $scope.createBotMessage = true;
                        mixpanelService.forceTrack('Kik Login No Bots');
                    } else {
                        $scope.kikLogin = true;
                        $scope.message = 'error';

                        mixpanelService.forceTrack('Kik Login Failed');
                    }
                });
            }
        }, true);
    };

    function scanLogin() {
        $http.get('/api/v1/login')
        .success(function(data) {
            $scope.kikCode = data.code;
            socketService.init(data.socketId, data.socketToken);
        })
        .error(function() {
            $scope.codeError = true;
            $scope.kikCode = '/assets/img/kikcodefail.png';
            $scope.message = 'errorKikCode';

            mixpanelService.forceTrack('Login Kik Code Error');
        });
    }

    function devLogin() {
        var username = $location.search().username;
        $http.get('/api/v1/debug/session', {params: {username: username}})
        .success(function(data) {
            $location.search('username', null);
            socketService.closeSocket();
            animateLogin(data, function() {
                authService.setEngineCookie(data.cookie);
            });
        });
    }

    function animateLogin(data, callback) {
        $scope.message = 'success';
        $timeout(function() {
            if (data.new_bot) {
                storageService.setItem('last-route', '/engine');
            }
            if (!data.tos) {
                $location.path('/tos');
            } else {
                var path = storageService.getItem('last-route');
                if(!path || path === '/home') {
                    path = '/reporting';
                }
                $location.path(path);
                storageService.removeItem('last-route');
            }
            callback();
        }, 700);
    }

    init();

    $scope.createBot = function() {
        $scope.createBotMessage = false;
        $scope.showScanLoader = true;
        $scope.message = 'kikLogin';
        var DATA_TO_SIGN = {data: 'create'};
        kikService.sign(JSON.stringify(DATA_TO_SIGN), function(signedData, username, host) {
            if (!signedData) {
                $scope.$apply(function() {
                    $scope.showScanLoader = false;
                    $scope.createBotMessage = true;
                    $scope.message = 'createBotTerminated';
                });
            } else {
                $scope.showScanLoader = true;
                $http.post(
                    '/api/v1/botsworth/bot/kik_create',
                    {
                        'signedData': signedData,
                        'username': username,
                        'host': host
                    }
                ).success(function() {
                    kikService.openConversation(BOTSWORTH_USERNAME);
                    mixpanelService.forceTrack('Kik Login Botsworth Create');
                })
                .error(function(data, status) {
                    $scope.showScanLoader = false;
                    if (status === 409) {
                        $scope.creatingBotMessage = true;
                        mixpanelService.forceTrack('Kik Login Botsworth Conflict');
                    } else {
                        $scope.kikLogin = true;
                        $scope.message = 'error';
                        mixpanelService.forceTrack('Kik Login Botsworth Create Failed');
                    }
                });
            }
        }, true);
    };

    $scope.openConvo = function() {
        kikService.openConversation(BOTSWORTH_USERNAME);
    };

    $scope.$watch('showScanLoader', function(current) {
        if (!current) {
            $scope.waiting = false;
            $scope.loadedCodeOnce = true;
            if (showTerminatedMessage) {
                $scope.message = 'loginTerminated';
                showTerminatedMessage = false;
            }
        }
    });

    $scope.$on('LoginSuccess', function(event, data) {
        $scope.waiting = false;
        if (data && data.cookie) {
            socketService.closeSocket();
            $scope.$apply(function() {
                $scope.success = true;

                animateLogin(data, function() {
                    authService.setEngineCookie(data.cookie);

                    $http.get('/api/v1/contact')
                        .error(function() {
                            Dialog.alert('Error', 'An error occurred while loading your information.');
                        })
                        .success(function(response) {
                            alertService.setShowAppleIdAlert(!response.apple_developer_id);
                        });
                });
            });

            mixpanelService.forceTrack('Login Success');
        } else {
            $scope.$apply(function() {
                $scope.message = 'errorToken';
                $timeout(init, 800);
            });

            mixpanelService.forceTrack('Login Token Error');
        }
    });

    $scope.$on('NoBots', function() {
        $scope.$apply(function() {
            $scope.message = 'noBots';
            $timeout(init, 800);
        });

        mixpanelService.forceTrack('Login No Bots');
    });

    $scope.$on('ExpiredKey', function() {
        $scope.$apply(function() {
            $scope.message = 'expiredKey';
            $timeout(init, 800);
        });

        mixpanelService.forceTrack('Login Expired Key');
    });

    $scope.$on('WaitingForConfirmation', function() {
        $scope.$apply(function() {
            $scope.waiting = true;
            $timeout(function() {
                $scope.message = 'waitingConfirmation';
            }, 200);
        });

        mixpanelService.forceTrack('Login Waiting Confirmation');
    });

    $scope.$on('EmailRequired', function() {
        $scope.$apply(function() {
            $scope.waiting = true;
            $timeout(function() {
                $scope.message = 'emailRequired';
            }, 200);
        });

        mixpanelService.forceTrack('Login Email Verification Required');
    });

    var showTerminatedMessage = false;
    $scope.$on('LoginTerminated', function() {
        $scope.$apply(function() {
            showTerminatedMessage = true;
            $timeout(init, 0);
        });

        mixpanelService.forceTrack('Login Terminated');
    });

    $scope.$on('socketError', function() {
        $scope.$apply(function() {
            $timeout(init, 800);
        });

        mixpanelService.forceTrack('Login Socket Error');
    });

    $scope.$on('sessionDataUpdated', init);

    $scope.$on('$destroy', function() {
        socketService.closeSocket();
    });

    var authUser = $location.search().authuser;

    if (parseInt(authUser) === 1) {
        $timeout(function() {
            Dialog.alert('Access Denied', 'Please log in with an authorized account and then try again')
            .result.then(function() {
                $window.location.href = '/logout';
                authService.clearAuthCookies();
            });
        }, 300);
    }

    $scope.trackHelp = function() {
        mixpanelService.forceTrack('Login Help');
    };

    $scope.shareFacebook = function() {
        var url = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(SHARE_URL);
        $window.open(url, 'pop', 'width=600, height=400, scrollbars=no');
    };

    $scope.shareTwitter = function() {
        var url = 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(SHARE_URL);
        $window.open(url, 'pop', 'width=600, height=400, scrollbars=no');
    };

    $scope.shareLinkedIn = function() {
        var url = 'https://www.linkedin.com/cws/share?url=' + encodeURIComponent(SHARE_URL);
        $window.open(url, 'pop', 'width=600, height=400, scrollbars=no');
    };

    $scope.scanCodeTutorial = function() {
        $modal.open({
            templateUrl: 'views/scan-code-tutorial-dialog.html',
            windowClass: 'scan-code-tutorial-dialog'
        });
    };
}]);
